import { InjectionToken } from '@angular/core';

const EFFY_ENVIRONMENT = new InjectionToken('EffyEnvironment');
const API_KEY = new InjectionToken('ApiKey');

var EffyEnvironment;
(function (EffyEnvironment) {
    EffyEnvironment["Dev"] = "dev";
    EffyEnvironment["Rct"] = "rct";
    EffyEnvironment["Prod"] = "prod";
})(EffyEnvironment || (EffyEnvironment = {}));

/**
 * Generated bundle index. Do not edit.
 */

export { API_KEY, EFFY_ENVIRONMENT, EffyEnvironment };
